import './email.css';
import React from "react";
import { motion } from 'framer-motion';

export default function Email () {
    const [result, setResult] = React.useState("");

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending....");
        const formData = new FormData(event.target);

        formData.append("access_key", "5692649e-822e-4252-91f9-ae94785ff460");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            setResult({message: "Got it! I'll be in touch!", status: "success"});
            // event.target.reset();
        } else {
            setResult({ message: data.message, status: "error" });
            // console.log("Error", data);
            // setResult(data.message);
        }
    };
    
    return (
        
        <section className="email">
            <form onSubmit={onSubmit}>
                <h2>Send me an email :)</h2>
                <div className="input-box">
                    <label>Name </label>
                    <input type="text" className="field" placeholder="Full name" name="name" required />
                </div>
                <div className="input-box">
                    <label>Email </label>
                    <input type="email" className="field" placeholder="you@example.com" name="email" required />
                </div>
                <div className="input-box">
                    <label>Message </label>
                    <textarea name="message" className="field mess" placeholder="Tell me something!" required></textarea>
                </div>
                <motion.button 
                    whileHover={{ scale: 1.2 }}
                    whileTap={{ scale: 0.8 }} 
                    type="submit">Send message
                </motion.button>

                {result && (
                    <p className={`form-message ${result.status}`}>
                        {result.message}
                    </p>
                    )}
                    
            </form>
        </section>

    );
}
